function isEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email.toLowerCase());
}

export const validate = ({ firstname, lastname, email, message }) => {
	const errors = {};

	if (firstname === "") errors.firstname = "Please enter a firstname";
	else if (lastname === "") errors.lastname = "Please enter a lastname";
	else if (email === "") errors.email = "Please enter an email";
	else if (!isEmail(email)) errors.email = "Please enter a valid email";
	else if (message === "") errors.message = "Please enter a message";

	return { errors, isValid: Object.entries(errors).length === 0 };
};
